// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/feedback/Alert.jsx

import React from "react";
import ActionGroup from "../actions/ActionGroup";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function Alert({
  title,
  children,
  tone = "informational",
  icon = null,
  actions = [],
  className = "",
}) {
  const role = tone === "danger" ? "alert" : "status";

  return (
    <section
      role={role}
      className={joinClassNames(
        "oasys-alert",
        `oasys-alert--${tone}`,
        className
      )}
    >
      {icon ? (
        <div className="oasys-alert__icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}

      <div className="oasys-alert__content">
        {title ? <h3 className="oasys-alert__title">{title}</h3> : null}
        {children ? <div className="oasys-alert__message">{children}</div> : null}

        <ActionGroup
          actions={actions}
          density="compact"
          className="oasys-alert__actions"
        />
      </div>
    </section>
  );
}
